import { useState } from "react";
import { Button, Icon, Modal, Popup, Table } from "semantic-ui-react";
import { Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal, ConfirmModal } from "../../../Shared";
import { RoleForm } from "../RoleForm";
import { useLanguage } from "../../../../contexts";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const roleController = new Role();

export function RoleItem(props) {
  const { role, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const openUpdateUser = () => {
    setTitleModal(`${t("update")} ${role.name}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setDeleteError("");
    setIsDelete(false);
    setConfirmMessage(
      role.active
        ? `${t("inactive_role")} ${role.name}`
        : `${t("active_role")}${role.name}`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await roleController.updateRole(accessToken, role._id, {
        active: !role.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setDeleteError("");
    setConfirmMessage(`${t("confirm_delete_role")} "${role.name}"?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await roleController.deleteRole(accessToken, role._id);
      onOpenCloseConfirm();
      onReload();
    } catch (error) {
      setDeleteError(error.msg || "Error en el servidor, intente nuevamente.");
      onOpenCloseConfirm();
      setShowErrorModal(true);
    }
  };

  return (
    <>
      <Table.Row>
        <Table.Cell>{role.name}</Table.Cell>
        <Table.Cell>
          <Popup
            content={t("edit")}
            trigger={
              <Button icon primary onClick={openUpdateUser}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content={role.active ? t("deactivate") : t("activate")}
            trigger={
              <Button
                icon
                color={role.active ? "orange" : "teal"}
                onClick={openDesactivateActivateConfim}
              >
                <Icon name={role.active ? "ban" : "check"} />
              </Button>
            }
          />
          <Popup
            content={t("delete")}
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </Table.Cell>
      </Table.Row>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal} size="tiny">
        <RoleForm onClose={onOpenCloseModal} onReload={onReload} role={role} />
      </BasicModal>

      <ConfirmModal
        open={showConfirm}
        title={isDelete ? t("delete") : t("activate_deactivate")}
        content={confirmMessage}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        onCancel={onOpenCloseConfirm}
        danger={isDelete}
      />

      <Modal open={showErrorModal} onClose={() => setShowErrorModal(false)} size="tiny">
        <Modal.Header>
          <Icon name="warning sign" color="yellow" /> Advertencia
        </Modal.Header>
        <Modal.Content style={{ padding: "2rem 2rem 1.5rem" }}>
          {deleteError}
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={() => setShowErrorModal(false)}>Aceptar</Button>
        </Modal.Actions>
      </Modal>

      {/* Este es el contenedor que maneja las tostadas */}
            <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick={true}
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
    </>
  );
}
